module.exports = "<div class=\"card-item\">\n  <div class=\"header-text\"> Address </div>\n  <label>\n    <div class=\"layer\">\n      {{addressThai}} {{zipCode}}\n    </div>\n  </label>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/address-executive-summary/address-executive-summary.component.html
// module id = ../../../../../src/app/securities-level/address-executive-summary/address-executive-summary.component.html
// module chunks = main